import React from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';

import { onboardColors } from '../../theme/onboardTokens';
import { font, palette } from '../styles';
import { usePortalCompact } from '../usePortalCompact';

interface Props {
  src: string;
  fileName: string;
  // Images render as <img>; everything else (PDFs) through the browser's viewer.
  kind?: 'pdf' | 'image';
}

/**
 * PDF preview with a "Preview" tab and file name, styled after the approval
 * page's offer file preview (`.oa-preview` in layouts/onboard_approval).
 */
const PortalPreviewFrame: React.FC<Props> = ({ src, fileName, kind = 'pdf' }) => {
  const compact = usePortalCompact();

  return (
    <div
      style={{
        background: onboardColors.surface.previewFrame,
        borderRadius: 8,
        overflow: 'hidden',
        height: compact ? '60vh' : 500,
        minHeight: compact ? 360 : undefined,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{ height: 34, minHeight: 34, display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            background: onboardColors.surface.previewTab,
            height: 34,
            borderRadius: '8px 0 0 0',
            display: 'flex',
            alignItems: 'center',
            padding: '0 10px',
            gap: 6,
            flexShrink: 0,
            color: onboardColors.neutral.textBody
          }}
        >
          <VisibilityIcon sx={{ fontSize: 16 }} />
          <span style={{ fontFamily: font, fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap' }}>
            Preview
          </span>
        </div>
        <span
          style={{
            flex: 1,
            paddingLeft: compact ? 12 : 16,
            paddingRight: 12,
            fontFamily: font,
            fontSize: 14,
            fontWeight: 600,
            color: onboardColors.neutral.textStrong,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {fileName}
        </span>
      </div>
      <div style={{ flex: 1, background: palette.uploadBg, overflow: 'hidden' }}>
        {kind === 'image' ? (
          <img
            alt={fileName}
            src={src}
            style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
          />
        ) : (
          <iframe
            src={`${src}#toolbar=0`}
            style={{ display: 'block', width: '100%', height: '100%', border: 'none' }}
            title={fileName}
          />
        )}
      </div>
    </div>
  );
};

export default PortalPreviewFrame;
